// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsIamGroupsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-iam-groups_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="m33.13 31.96-7-7a.5.5 0 0 1-.09-.58 5 5 0 0 0-.73-5.64 4.6 4.6 0 0 0-3.86-1.33c-1.43.18-2.7 1-3.46 2.27a4.7 4.7 0 0 0 6.2 6.55.5.5 0 0 1 .58.1l1.2 1.19q.15.16.14.39l-.09 1.25h1.38a.5.5 0 0 1 .35.15l.6.6q.15.14.15.34l.02 1.4 1.23-.1a.5.5 0 0 1 .4.15l1.09 1.1 1.76.44zm1.02-.14-.21 2.1a.5.5 0 0 1-.62.44l-2.46-.63a1 1 0 0 1-.23-.13l-1.03-1.03-1.54.13a.5.5 0 0 1-.54-.5l-.02-1.73-.3-.3h-1.71a.5.5 0 0 1-.5-.54l.1-1.57-.78-.78a5.72 5.72 0 0 1-7.18-8.12 5.7 5.7 0 0 1 4.2-2.74 5.6 5.6 0 0 1 4.69 1.62c1.8 1.8 1.9 4.53 1.07 6.46L34 31.42q.16.16.14.4M22.74 21.21a1.1 1.1 0 0 0-1.55 0 1.1 1.1 0 0 0 0 1.55c.41.41 1.13.41 1.55 0a1.1 1.1 0 0 0 0-1.55m.7-.7a2.1 2.1 0 1 1-2.97 2.96 2.1 2.1 0 0 1 2.97-2.97M9.66 13.3a7 7 0 0 0 .05.84.5.5 0 0 1-.42.5C8.04 14.98 6 15.97 6 18.88l.01.32c.14 2.46 2.49 3.8 4.63 3.8H15v1h-4.36c-3.06-.01-5.48-2.05-5.63-4.75L5 18.88a5.06 5.06 0 0 1 3.68-5.1l-.02-.47a7.6 7.6 0 0 1 4.37-6.69c2.9-1.22 5.99-.62 8.24 1.63a10 10 0 0 1 1.88 2.5Q24 10 25.1 10c1.46 0 3.09 1.22 3.38 3.88q4.52 1.09 4.53 5.1c0 2.93-1.28 4.57-3.92 5.02l-.16-.99c1.43-.24 3.08-.92 3.08-4.03 0-3.02-2.34-3.84-4.1-4.2a.5.5 0 0 1-.4-.46c-.11-1.96-1.1-3.32-2.4-3.32-.67 0-1.2.3-1.7.98a.5.5 0 0 1-.87-.13 8 8 0 0 0-1.96-2.88 6.4 6.4 0 0 0-7.16-1.42 6.6 6.6 0 0 0-3.75 5.77"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-iam-groups_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsIamGroups",
);
export default AwsIamGroupsIcon;
